<mat-tab-group>
  <mat-tab label="Teams">
    <div class="cards">
      <app-card
        label="Teams - Basic"
        title="Basic"
        description="Create a basic Teams with a connected SharePoint teamsite.<br><br> Use it to chat together and save and share your files."
        moreInformation="https://bernerfachhochschule.sharepoint.com/sites/mybfh-Bernie-RDM-de/SitePages/Microsoft-Teams.aspx"
        image="../assets/images/MSTeamsIcon.svg"
        [formRef]="OrderFormStandardTeamsComponent"
      ></app-card>
      <app-card
        label="Teams - Clone"
        title="Clone"
        description="Clone an existing Teams with its members, apps, channels, settings and tabs. <br><br> Use it to recreate a teams without copying its content."
        moreInformation="https://bernerfachhochschule.sharepoint.com/sites/mybfh-Bernie-RDM-de/SitePages/Microsoft-Teams.aspx"
        image="../assets/images/MSTeamsIcon.svg"
        [formRef]="OrderFormCloneTeamsComponent"
      ></app-card>
    </div>
  </mat-tab>
  <mat-tab label="SharePoint">
    <div class="cards">
      <app-card
        label="SharePoint - Basic"
        title="Basic"
        description="Create a basic Sharepoint Site.<br><br>Use it to save your files and collaborate on them together."
        moreInformation="https://bernerfachhochschule.sharepoint.com/sites/mybfh-Bernie-RDM-de/SitePages/SharePoint.aspx"
        image="../assets/images/SharePointIcon.svg"
        [formRef]="OrderFormStandardSharepointComponent"
      ></app-card>
    </div>
  </mat-tab>
  @if (authService.isStaff() || authService.isAdmin()) {
    <mat-tab label="RIS">
      <app-status-bar
        style="margin: 16px 20px 0; display: block"
        type="warning"
        icon="../assets/icons/Alert-Diamond--Streamline-Ultimate.svg"
      >
        <span>{{ 'RIS_PROJECT_CREATION_WARNING' | translate }}</span>
      </app-status-bar>
      <div class="cards">
        <app-card
          label="RIS with Teams"
          title="RIS Teams"
          description="Create a BFH research project with a Teams.<br><br>Use it to research, share data and consult together within a Teams."
          moreInformation="https://bernerfachhochschule.sharepoint.com/sites/mybfh-RIS-de"
          image="./assets/images/BFHIcon.png"
          [formRef]="OrderFormRisComponent"
          [isTeam]="true"
        ></app-card>
        <app-card
          label="RIS with Site"
          title="RIS Site"
          description="Create a BFH research project site.<br><br>Use it to research and share data within SharePoint."
          moreInformation="https://bernerfachhochschule.sharepoint.com/sites/mybfh-RIS-de"
          image="./assets/images/BFHIcon.png"
          [formRef]="OrderFormRisComponent"
          [isTeam]="false"
        ></app-card>
      </div>
    </mat-tab>
  }
  @if (authService.isStaff() || authService.isAdmin()) {
    <mat-tab [label]="'Others' | translate">
      <div class="cards">
        <app-card
          label="Personal Bookings Calendar"
          title="Personal Bookings Calendar"
          description="PERSONAL_BOOKINGS_CARD_DESCRIPTION"
          moreInformation="https://bernerfachhochschule.sharepoint.com/sites/mybfh-Bernie-RDM-de/SitePages/Pers%C3%B6nlicher-Bookings-Kalender.aspx"
          image="./assets/images/BookingsIcon.svg"
          link="https://bookings.cloud.microsoft/bookwithme/me"
        ></app-card>
        <app-card
          label="Business Bookings Calendar"
          title="Business Bookings Calendar"
          description="BUSINESS_BOOKINGS_CARD_DESCRIPTION"
          moreInformation="https://bernerfachhochschule.sharepoint.com/sites/mybfh-Bernie-RDM-de/SitePages/Business-Bookings-Kalender.aspx"
          image="./assets/images/BookingsIcon.svg"
          [formRef]="OrderFormBookingsComponent"
        ></app-card>
      </div>
    </mat-tab>
  }
</mat-tab-group>
